import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=3a903da8"
import script from "./Practice.vue?vue&type=script&lang=ts"
export * from "./Practice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports